<template>
  <div class="bottom">
    <form v-if="!emptyFiltersObject" @submit.prevent="submitForm">
      <b-container class="form-container">
        <div role="group" aria-labelledby="planSelection">
          <h3 class="visually-hidden" id="planSelection">Plan Information:</h3>
          <b-row>
            <b-col class="form-group">
              <label for="market_type"
                >Market Type<span class="required">&nbsp;*</span></label
              >
              <b-form-select
                aria-label="Select Market Type"
                required
                v-model="formSelections.market_type"
                class="form-control"
                id="market_type"
                @change="clearPlanType()"
              >
                <b-form-select-option :value="null" disabled
                  >Select Market Type</b-form-select-option
                >
                <b-form-select-option
                  v-for="(value, key) in formFilters"
                  :value="key"
                  :key="key"
                  >{{ key }}</b-form-select-option
                >
              </b-form-select>
            </b-col>
            <b-col class="form-group empty-div"></b-col>
          </b-row>
          <b-row>
            <b-col class="form-group" :disabled="!showPlanTypeField">
              <label for="plan_type"
                >Plan Type<span class="required">&nbsp;*</span></label
              >
              <b-form-select
                v-model="formSelections.plan_type"
                class="form-control"
                aria-label="Select Plan Type"
                id="plan_type"
                @change="clearPlanName()"
                :disabled="!showPlanTypeField"
              >
                <b-form-select-option :value="null" disabled
                  >Select Plan Type</b-form-select-option
                >
                <b-form-select-option
                  v-for="(value, key) in formFilters[
                    formSelections.market_type
                  ]"
                  :value="key"
                  :key="key"
                  >{{ key }}</b-form-select-option
                >
              </b-form-select>
            </b-col>
            <b-col class="form-group" :disabled="!showPlanNameField">
              <label for="plan_name"
                >Plan Name<span class="required">&nbsp;*</span></label
              >
              <b-form-select
                required
                v-model="formSelections.plan_name"
                class="form-control"
                aria-label="Select Plan Name"
                id="plan_name"
                :disabled="!showPlanNameField"
              >
                <b-form-select-option :value="null" disabled
                  >Select Plan Name</b-form-select-option
                >
                <b-form-select-option
                  v-for="(value, key) in plan_names"
                  :value="value"
                  :key="key"
                  >{{ value }}</b-form-select-option
                >
              </b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="form-group">
              <label
                for="start_date"
                aria-label="Enter start date in month month day day year year year format"
                >Start Date<span class="required">&nbsp;*</span></label
              >
              <b-form-input
                required
                type="date"
                v-model="formSelections.start_date"
                class="form-control"
                id="start_date"
              ></b-form-input>
            </b-col>
            <b-col class="form-group empty-div"></b-col>
          </b-row>
        </div>
        <div role="group" aria-labelledby="addressInfo">
          <h3 class="visually-hidden" id="addressInfo">Address Information:</h3>
          <b-row>
            <b-col class="form-group">
              <label for="Address"
                >Street Address<span
                  class="required"
                  :class="{ disabled: !showAddressFields }"
                  >&nbsp;*</span
                ></label
              >
              <b-form-input
                required
                type="text"
                v-model="formSelections.address_ln_1"
                placeholder="Street Address"
                class="form-control"
                aria-label="Enter street address"
                id="Address"
                :disabled="!showAddressFields"
              ></b-form-input>
            </b-col>
            <b-col class="form-group">
              <label for="city"
                >City<span
                  class="required"
                  :class="{ disabled: !showAddressFields }"
                  >&nbsp;*</span
                ></label
              >
              <b-form-input
                required
                type="text"
                v-model="formSelections.city"
                placeholder="City"
                class="form-control"
                aria-label="Enter city"
                id="city"
                :disabled="!showAddressFields"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row :disabled="!showAddressFields">
            <b-col class="form-group">
              <label for="state"
                >State<span
                  class="required"
                  :class="{ disabled: !showAddressFields }"
                  >&nbsp;*</span
                ></label
              >
              <b-form-select
                required
                v-model="formSelections.state"
                class="form-control"
                id="state"
                aria-label="Select State"
                :disabled="!showAddressFields"
              >
                <b-form-select-option :value="null" disabled
                  >Select State</b-form-select-option
                >
                <b-form-select-option
                  v-for="value in states"
                  :value="value"
                  :key="value"
                  >{{ value }}</b-form-select-option
                >
              </b-form-select>
            </b-col>
            <b-col class="form-group">
              <label for="zip"
                >Zipcode<span class="required">&nbsp;*</span></label
              >
              <b-form-input
                required
                type="text"
                v-model="formSelections.zip"
                placeholder="Zipcode"
                class="form-control"
                aria-label="Enter zipcode"
                id="zip"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <BottomButton
              style="max-width: 120px"
              :loading="false"
              :text="'Submit'"
              type="submit"
              ref="submit"
            />
          </b-row>
        </div>
      </b-container>
    </form>
    <div v-else class="bottom"> 
      <h3  style="text-align: center;" ><br><br>There are currently no retired broadband labels.<br>Check back later.</h3>
      <br>
      <b-col>
        <b-row>
        <BottomButton
          style="max-width: 120px"
          :loading="false"
          :text="'Back'"
          @advance="back"
          ></BottomButton>
        </b-row>
      </b-col>
    </div> 
  </div>
</template>
<script>
import BottomButton from "./BottomButton";
import axios from "axios";
export default {
  name: "BroadbandLabelForm",
  components: {
    BottomButton,
  },
  props: {
    currStep: Number,
    selections: Object,
  },
  data() {
    return {
      emptyFiltersObject: false,
      selectplan_type: "mobility-postpaid",
      formFilters: {},
      formSelections: {
        market_type: null,
        plan_type: null,
        plan_name: null,
        start_date: null,
        zip: null,
        address_ln_1: null,
        city: null,
        state: null,
      },
      states: [
        "AK",
        "AL",
        "AR",
        "AS",
        "AZ",
        "CA",
        "CO",
        "CT",
        "DC",
        "DE",
        "FL",
        "GA",
        "GU",
        "HI",
        "IA",
        "ID",
        "IL",
        "IN",
        "KS",
        "KY",
        "LA",
        "MA",
        "MD",
        "ME",
        "MI",
        "MN",
        "MO",
        "MP",
        "MS",
        "MT",
        "NC",
        "ND",
        "NE",
        "NH",
        "NJ",
        "NM",
        "NV",
        "NY",
        "OH",
        "OK",
        "OR",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UM",
        "UT",
        "VA",
        "VI",
        "VT",
        "WA",
        "WI",
        "WV",
        "WY",
      ],
    };
  },
  created() {
    this.getFccFormFilters();
    this.preLoadFormSelections();
  },
  computed: {
    showAddressFields() {
      if (
        this.formSelections.market_type === null ||
        this.formSelections.plan_type === null
      )
        return true;
      if (
        this.formFilters[this.formSelections.market_type][
          this.formSelections.plan_type
        ].customer_info === "zip"
      )
        return false;
      return true;
    },
    showPlanTypeField() {
      if (this.formSelections.market_type === null) return false;
      return this.formFilters[this.formSelections.market_type] !== undefined;
    },
    showPlanNameField() {
      if (this.formSelections.plan_type === null) return false;
      return (
        this.formFilters[this.formSelections.market_type][
          this.formSelections.plan_type
        ] !== undefined
      );
    },
    plan_names() {
      if (
        this.formSelections.market_type != null &&
        this.formSelections.plan_type != null
      ) {
        return this.formFilters[this.formSelections.market_type][
          this.formSelections.plan_type
        ].plans;
      } else {
        return [];
      }
    },
  },
  methods: {
    preLoadFormSelections() {
      Object.keys(this.selections).forEach((key) => {
        if (this.selections[key]) {
          this.formSelections[key] = this.selections[key];
        }
      });
    },
    advance() {
      let advanceTo = this.currStep + 1;
      this.$emit("advance", advanceTo);
    },
    clearPlanName() {
      this.formSelections.plan_name = null;
    },
    clearPlanType() {
      this.formSelections.plan_type = null;
      this.clearPlanName();
    },
    getFccFormFilters() {
      axios
        .get("/fcc/fcc-label-filters")
        .then((response) => {
          this.formFilters = response.data;
          if ( Object.keys(this.formFilters).length === 0 ) {
            this.emptyFiltersObject = true;
          } 
        })
        .catch((error) => {
          console.error(error);
          if ( Object.keys(this.formFilters).length === 0 ) {
            this.emptyFiltersObject = true;
          }
        });
    },
    validateCustomerInfoForm() {
      if (
        this.formSelections.market_type === null ||
        this.formSelections.plan_type === null ||
        this.formSelections.plan_name === null ||
        this.formSelections.start_date === null ||
        this.formSelections.zip === null
      ) {
        if (
          this.showAddressFields &&
          (this.formSelections.address_ln_1 === null ||
            this.formSelections.city === null ||
            this.formSelections.state === null)
        ) {
          this.$noty.error("Please fill out all required fields", {
            layout: "top",
          });
          return false;
        }
        if (!this.showAddressFields) {
          this.$noty.error("Please fill out all required fields", {
            layout: "top",
          });
          return false;
        }
      }
      return true;
    },
    submitForm() {
      let valid = this.validateCustomerInfoForm();
      if (!valid) return;
      // Logic to submit the form
      // request to api to validate data and get a response
      axios
        .post("/fcc/fetch-fcc-label", this.formSelections)
        .then((response) => {
          this.$emit("fcc_label_id", response.data["fcc_label_id"]);
          this.$emit("taxgeocode", response.data["tax_geocode"]);
          this.$emit("comm_eff_dt", response.data["comm_eff_dt"]);
          this.$emit("acct_type", response.data["acct_type"])
          this.$emit("sub_type", response.data["sub_type"])
          this.$emit("fcc_form_selections", this.formSelections);
          this.advance();
        })
        .catch(() => {
          this.$noty.error(
            "Error generating broadband label, try again later.",
            { layout: "top" }
          );
        });
    },
    back(){
      this.$router.push('/promotions');
    },
  },
  watch: {
    showAddressFields(value) {
      if (!value) {
        this.formSelections.address_ln_1 = null;
        this.formSelections.city = null;
        this.formSelections.state = null;
      }
    },
  },
};
</script>
<style scoped>
.form-group {
  min-width: 375px;
  max-width: 375px;
}

.bottom {
  min-height: 464px;
}

.required {
  color: red;
  font-size: 0.8rem;
}

.row {
  justify-content: center;
}

.disabled {
  display: none;
}

.visually-hidden {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  padding: 0 !important;
  border: 0 !important;
  white-space: nowrap !important;
  clip: rect(1px 1px 1px 1px) !important; /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
}

@media screen and (max-width: 799px) {
  .empty-div {
    display: none;
  }
}
</style>
